import { Header } from './Header';
import { Banniere } from './Banniere';
import { About } from './About';
import { Service } from './Ministere';
import { Portfolio } from './Dgid';
import { Blog } from './Blog';
import { Contact } from './Contact';
import { Footer } from './Footer';
import { useState } from 'react';

export const Home = ()=>{
    const [menuActive, setMenuActive] = useState(false);

    const handleMenuClick = () => {
      setMenuActive(prevState => !prevState);
    };
    return(
        <>
        <Header menuActive={menuActive} handleMenuClick={handleMenuClick}/>
        <Banniere/>
        <About/> 
        <Service/>
        <Portfolio/> 
       
        <Contact/>
        <Footer/>
        </>
    )
}